import { Result, Button } from "antd";
import { FormattedMessage } from "react-intl";

const LoadError = ({ notFound, onClick, message, errorWhat, buttonText }) => (
  <Result
    status={notFound ? "404" : "warning"}
    title={
      message || (
        <FormattedMessage
          values={{ what: errorWhat || "" }}
          id="messages.loadTable.error"
          defaultMessage="Při načítání {what} nastala chyba."
        />
      )
    }
    extra={
      onClick && (
        <Button type="primary" onClick={onClick}>
          {buttonText || (
            <FormattedMessage
              id="messages.loadError"
              defaultMessage="Načíst znovu"
            />
          )}
        </Button>
      )
    }
  />
);

export default LoadError;
